export const validHeroScreenIds = ['code', 'plan', 'collaborate', 'automate', 'secure'] as const
export type HeroScreenId = (typeof validHeroScreenIds)[number]

interface HeroVisual {
  type: 'image' | 'video'
  url: {
    mobile?: string
    desktop: string
  }
  duration: number // seconds
}

interface HeroScreen {
  id: HeroScreenId
  alt: string
  visuals: HeroVisual[]
}

// TODO: Update mobile assets once known
export const SCREENS: HeroScreen[] = [
  {
    id: 'code',
    // TODO: Update once known
    alt: '',
    visuals: [
      {
        type: 'video',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/code-1_mobile.mp4',
          desktop: '/images/modules/site/home24/intro/carousel/code-1_desktop.mp4',
        },
        duration: 15,
      },
    ],
  },
  {
    id: 'plan',
    // TODO: Update once known
    alt: '',
    visuals: [
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/plan-1_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/plan-1_desktop.webp',
        },
        duration: 1,
      },
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/plan-2_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/plan-2_desktop.webp',
        },
        duration: 1,
      },
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/plan-3_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/plan-3_desktop.webp',
        },
        duration: 3,
      },
    ],
  },
  {
    id: 'collaborate',
    // TODO: Update once known
    alt: '',
    visuals: [
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/collaborate-1_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/collaborate-1_desktop.webp',
        },
        duration: 1,
      },
      {
        type: 'image',
        url: {
          desktop: '/images/modules/site/home24/intro/carousel/collaborate-2_desktop.webp',
        },
        duration: 2,
      },
    ],
  },
  {
    id: 'automate',
    // TODO: Update once known
    alt: '',
    visuals: [
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/automate-1_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/automate-1_desktop.webp',
        },
        duration: 1,
      },
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/automate-2_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/automate-2_desktop.webp',
        },
        duration: 1,
      },
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/automate-3_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/automate-3_desktop.webp',
        },
        duration: 1,
      },
    ],
  },
  {
    id: 'secure',
    // TODO: Update once known
    alt: '',
    visuals: [
      {
        type: 'image',
        url: {
          mobile: '/images/modules/site/home24/intro/carousel/secure-1_mobile.webp',
          desktop: '/images/modules/site/home24/intro/carousel/secure-1_desktop.webp',
        },
        duration: 1,
      },
      {
        type: 'image',
        url: {
          desktop: '/images/modules/site/home24/intro/carousel/secure-2_desktop.webp',
        },
        duration: 2,
      },
    ],
  },
]

export const getScreen = (screenId: HeroScreenId) => SCREENS.find(screen => screen.id === screenId)
